import React, { useContext, useId } from "react";
import { Field } from "./Fields";
import ReviewIssueHint, {
  CloseFieldEdit,
  ReviewIssueContext,
} from "./ReviewIssueHint";

export default function ReviewField({
  readOnly,
  id,
  label,
  value,
  displayValue = value,
  editor,
  className = "",
  ...props
}) {
  const labelId = useId();
  const selection = useContext(ReviewIssueContext);
  const indicated = selection && selection.id === id;
  const control = editor || (
    <Field id={id} label={label} value={value} {...props} />
  );
  if (!readOnly) return control;
  if (indicated && selection.editing) {
    return (
      <div className="premium-inline-editor">
        {control}
        <CloseFieldEdit onClick={selection.dismiss} />
      </div>
    );
  }
  return (
    <dl
      className={`premium-read-value ${className}${indicated ? " premium-issue-target" : ""}`.trim()}
    >
      <dt id={labelId}>{label}</dt>
      <dd
        id={id}
        tabIndex={id ? -1 : undefined}
        aria-labelledby={labelId}
        aria-describedby={indicated ? `${id}-hint` : undefined}
      >
        {displayValue === "" ? "-" : (displayValue ?? "-")}
      </dd>
      {indicated && (
        <dd>
          <ReviewIssueHint selection={selection} />
        </dd>
      )}
    </dl>
  );
}
